import { render, staticRenderFns } from "./BookMetaBlock.vue?vue&type=template&id=5999bd83"
import script from "./BookMetaBlock.vue?vue&type=script&lang=js"
export * from "./BookMetaBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports